module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Folder-error-3fb636e0066682bfdc6722f9052a9e55.svg";